import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { GetSettingDetailsCompleteAction } from 'app/modules/core/actions/setting';
import { CoordinateList } from '../models/coordinate-list';


@Component({
  selector: 'irar-google-map',
  styles: ['#map { height: 500px; width: 100%; }'],
  template: `
  <div>To view all documents associated with a specific area of concern, simply click on a red area on the map below to bring up the details and access documents for that selected site. Please note: The map cannot be in full screen mode to view the popup for the select area of concern.</div>
  <br/>
  <div #mapContainer id="map"></div>
  `
})
export class GoogleMapComponent implements AfterViewInit {
    @ViewChild('mapContainer') gmap: ElementRef;
    @Input() farmGps: CoordinateList[];
    @Input() aocGps: CoordinateList[];
    @Output() selectSite: EventEmitter<string> = new EventEmitter();

    farms: Array<google.maps.Polygon>;
    aocs: Array<google.maps.Polygon>;
    
    
    lat = 39.030931;
    lng = -76.885542;
    map: google.maps.Map;

    coordinates = new google.maps.LatLng(this.lat, this.lng);

    mapOptions: google.maps.MapOptions = {
      center: this.coordinates,
      zoom: 12,
      mapTypeId: 'hybrid'
    };
  
    mapInitializer() {
      this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);
      this.loadFarms();
      this.loadAocs();
     }
  
    ngAfterViewInit() {
      this.mapInitializer();
     }

     loadFarms(){
        this.farms = new Array<google.maps.Polygon>();
        let paths = new Array<google.maps.LatLng>();
        let id = 0;
        let polygonIndex = 0;
        for(let i=0; i< this.farmGps.length; i++){
            const point = this.farmGps[i];
            if (id != Number(point.id)){
                if(id > 0){
                    this.farms[polygonIndex].setPaths(paths);
                    this.farms[polygonIndex].setMap(this.map);
                    paths = new Array<google.maps.LatLng>();
                    polygonIndex++;
                }
                id = Number(point.id);
                this.farms[polygonIndex] = new google.maps.Polygon({
                    strokeColor: point.hexLineColor,
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: point.hexLineColor,
                    fillOpacity: .3
                });
            }
            paths.push(new google.maps.LatLng({ lat: Number(point.latitude), lng: Number(point.longitude) }));
        }
        this.farms[polygonIndex].setPaths(paths);
        this.farms[polygonIndex].setMap(this.map);
     }

     loadAocs(){
        this.aocs = new Array<google.maps.Polygon>();
        let paths = new Array<google.maps.LatLng>();
        let id = 0;
        let polygonIndex = 0;
        for(let i=0; i< this.aocGps.length; i++){
            const point = this.aocGps[i];
            if (id != Number(point.id)){
                if(id > 0){
                    this.aocs[polygonIndex].setPaths(paths);
                    this.aocs[polygonIndex].setMap(this.map);
                    paths = new Array<google.maps.LatLng>();
                    polygonIndex++;
                }
                id = Number(point.id);
                this.aocs[polygonIndex] = new google.maps.Polygon({
                    strokeColor: "#FF0000",
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillColor: "#FF0000",
                    fillOpacity: .3
                });
                this.aocs[polygonIndex].addListener("click", (event) => {
                    this.selectSite.emit(point.name);
                });
            }
            paths.push(new google.maps.LatLng({ lat: Number(point.latitude), lng: Number(point.longitude) }));
        }
        this.aocs[polygonIndex].setPaths(paths);
        this.aocs[polygonIndex].setMap(this.map);
     }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/google-map.ts